/* Widerruf-Formular (§ 356a BGB): postet die Widerrufserklaerung an den Cloudflare-Worker.
   Validierung clientseitig (Pflichtfelder + E-Mail), Erfolg/Fehler barrierearm angezeigt.
   Schickt zusaetzlich Honeypot (hp) + Turnstile-Token (Missbrauchsschutz) mit. */
(function () {
  var form = document.getElementById('WiderrufForm');
  if (!form) return;

  var container = form.closest('.widerruf-form') || document;
  var notif = form.querySelector('.widerruf-form__notification');
  var submitBtn = form.querySelector('.widerruf-form__submit');
  var successBox = container.querySelector('.widerruf-form__success');
  var workerUrl = form.getAttribute('data-worker-url');

  function attr(name) { return form.getAttribute(name) || ''; }
  function val(name) {
    var el = form.elements[name];
    return el ? el.value.trim() : '';
  }
  function validEmail(e) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e); }

  // Fehler anzeigen: Live-Region kuendigt die Meldung an; der Fokus geht auf das
  // betroffene Feld (nicht auf die Meldung selbst) -> keine Doppel-Ansage.
  function showError(msg, focusName) {
    notif.textContent = msg;
    notif.hidden = false;
    var el = focusName ? form.elements[focusName] : null;
    if (el && el.focus) el.focus();
    else if (notif.scrollIntoView) notif.scrollIntoView({ block: 'center' });
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    notif.hidden = true;

    var ts = form.elements['cf-turnstile-response'];
    var data = {
      name: val('name'),
      order_ref: val('order_ref'),
      email: val('email'),
      order_date: val('order_date'),
      reason: val('reason'),
      locale: attr('data-locale') || 'de',
      hp: val('hp'),
      turnstile_token: ts ? ts.value : ''
    };

    if (!data.name || !data.order_ref || !data.email) {
      var firstEmpty = !data.name ? 'name' : (!data.order_ref ? 'order_ref' : 'email');
      showError(attr('data-msg-required'), firstEmpty);
      return;
    }
    if (!validEmail(data.email)) { showError(attr('data-msg-email'), 'email'); return; }
    if (!workerUrl) { showError(attr('data-msg-error')); return; }

    var origLabel = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = attr('data-msg-sending');

    fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.body || !res.body.ok) throw new Error('server');
        var dt = res.body.submitted_at_display || '';
        successBox.querySelector('.widerruf-form__success-title strong').textContent = attr('data-success-title');
        successBox.querySelector('.widerruf-form__success-received').textContent =
          attr('data-success-received').replace('%DATETIME%', dt);
        successBox.querySelector('.widerruf-form__success-body').textContent = attr('data-success-body');
        form.hidden = true;
        successBox.hidden = false;
        successBox.focus();
        if (successBox.scrollIntoView) successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = origLabel;
        // Turnstile-Widget zuruecksetzen, damit ein neuer Versuch ein frisches Token bekommt.
        if (window.turnstile && typeof window.turnstile.reset === 'function') {
          try { window.turnstile.reset(); } catch (e) {}
        }
        showError(attr('data-msg-error'));
      });
  });
})();
